import React, { useId } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2, Separator } from '@betterment/samba-react';
import { CursorProvider } from '@betterment/shared-components';

import { AccountsFilter } from './account-filter/AccountsFilter';
import { BalanceDetailsSheet } from './balance-details/BalanceDetailsSheet';
import { BalanceChart } from './BalanceChart';
import { BalanceChartData } from './BalanceChartData';
import { UserBalancePerformanceDocument } from './graphql/userPerformanceBalance.generated';

import { DateRangeOption } from '../../../../graphql/schema';
import { PerformanceAccountsQuery } from '../../graphql/performanceAccounts.generated';

export const Balance: React.FC<{
  dateRangeOption: DateRangeOption;
  accounts: PerformanceAccountsQuery['performance']['accounts'];
}> = ({ dateRangeOption, accounts }) => {
  const [selectedIds, setSelectedIds] = React.useState<Set<string>>(new Set());

  const describeId = useId();
  const { data } = useGraphQLQuery(UserBalancePerformanceDocument, {
    variables: { dateRangeOption },
    throwOnError: true,
  });

  let startDate: Date | undefined;
  let endDate: Date | undefined;

  if (data?.performance.history) {
    const { history } = data.performance;
    if (history.timeSeries.length > 0) {
      startDate = new Date(history.timeSeries[0].date);
      endDate = new Date(history.timeSeries[history.timeSeries.length - 1].date);
    }
  }

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300', display: 'flex', justifyContent: 'space-between' }}>
        <H2 variant="title200">Balance</H2>
        <AccountsFilter accounts={accounts} selectedSetter={setSelectedIds} selectedAccountIds={selectedIds} />
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300' }}>
        <CursorProvider>
          <BalanceChartData totals={data?.performance.totals} dateRangeOption={dateRangeOption} />
          <BalanceChart history={data?.performance.history} balanceDetailsId={describeId} />
        </CursorProvider>
        <BalanceDetailsSheet data={data?.performance.totals} startDate={startDate} endDate={endDate} />
      </Card.Content>
    </Card>
  );
};
